<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productCost.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productCost.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <a-tabs type="card" v-model="default_active">
          <a-tab-pane :key="1">
            <span slot="tab">
              <i class="fas fa-qrcode"></i>
              <span class="ts-uppercase ts-ml-3">{{
                $t('productCost.serial')
              }}</span>
            </span>
            <SerialList />
          </a-tab-pane>
          <a-tab-pane :key="2">
            <span slot="tab">
              <i class="fas fa-cog"></i>
              <span class="ts-uppercase ts-ml-3">{{
                $t('productCost.sparePart')
              }}</span>
            </span>
            <SparePartList />
          </a-tab-pane>
        </a-tabs>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import SerialList from './components/serial-table-list.vue'
import SparePartList from './components/spare-part-table-list.vue'
export default {
  name: 'productCost',
  components: {
    SerialList,
    SparePartList
  },
  data() {
    return {
      default_active: 1
    }
  },
  methods: {
    callback() {}
  }
}
</script>
